import axios, { Method } from "axios";
import { flatten } from "lodash";
import queryString from "query-string";

export class Http {
    public baseUrl = `${import.meta.env.VITE_API_HOST}/api/v1/`;
    protected headers: Record<string, any> = {};

    static make = () => {
        return new Http();
    };

    get = (url: string, payload: Record<string, any>, headers = {}) => {
        return this.request("GET", url, payload, headers);
    };

    post = (url: string, payload: Record<string, any>, headers = {}) => {
        return this.request("POST", url, payload, headers);
    };

    put = (url: string, payload: Record<string, any>, headers = {}) => {
        return this.request("PUT", url, payload, headers);
    };

    delete = (url: string, payload: Record<string, any>, headers = {}) => {
        return this.request("DELETE", url, payload, headers);
    };

    withCaptcha = (token: string) => {
        this.headers["X-RECAPTCHA-TOKEN"] = token;

        return this;
    };

    request = (method: Method, url: string, payload: any, headers = {}) => {
        const instance = axios.create({
            baseURL: this.baseUrl,
            timeout: 90000,
            timeoutErrorMessage: "Your connection timed out, please try again.",
            headers: {
                ...this.headers,
                ...headers,
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
            },
        });

        instance.interceptors.response.use((response: any) => {
            return response;
        }, ((error: any) => {
            const apiError: {
                status: string,
                code: string,
                message: string,
                errors: any[]
            } = {
                status: '',
                code: '',
                message: '',
                errors: []
            };

            if (error.response) {
                apiError.status = error.response.status;
                apiError.code = error.response.data.code;
                apiError.message = error.response.data.message;

                if (error.response.data.errors) {
                    apiError.errors = flatten(Object.values(error.response.data.errors)); // for each entry create an array, then flatten.;
                }

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                console.log(error.request);
            } else {
                console.log(error);
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }

            console.log(error, apiError);


            return Promise.reject(apiError);
        }));

        return instance.request({
            url: url.replace(/\/$/, ""),
            method,
            params: method == "GET" ? payload : {},
            paramsSerializer: (params: any) => {
                return queryString.stringify(params, {
                    arrayFormat: "bracket",
                    skipEmptyString: true
                });
            },
            data: payload,
        });
    };

}